/* © 2024-2026 Johannes Roob. Proprietärer Code. Keine Nutzung oder Weitergabe ohne Erlaubnis. | Proprietary code. No use or distribution without permission. */

import htmx from "htmx.org";
import { FormManager } from "./util/FormManager.js";
import { DataGridManager } from "./util/DataGridManager.js";
import * as Table from "./controls/custom/Table.js";
import { Taskbar } from "./controls/custom/Taskbar.js";
import { mustClosest, mustQuerySelector } from "./util/must.js";

class Lvl {
    forms: FormManager = new FormManager();
    grids: DataGridManager = new DataGridManager();
}

declare global {
    var lvl: Lvl;
}

globalThis.lvl = new Lvl();;

document.addEventListener("DOMContentLoaded", () => {
    // FormManager
    const taskbar = document.getElementById("Taskbar");

    if (taskbar !== null) {
        lvl.forms.windowManager.taskbar = new Taskbar(taskbar);
    }

    const formHost = document.getElementById("FormHost");

    if (formHost !== null) {
        lvl.forms.formHost = formHost;
    }

    // Form
    document.querySelectorAll<HTMLElement>("div.Form").forEach(element => {
        lvl.forms.create(element);
    });

    // DataGrid
    document.querySelectorAll<HTMLElement>("div.DataGrid").forEach(element => {
        lvl.grids.create(element);
    });
});

htmx.onLoad(
    (element: Node) => {
        if (!(element instanceof HTMLElement)) {
            return;
        }

        // Form
        element.querySelectorAll<HTMLElement>("div.Form").forEach(element => {
            lvl.forms.create(element);
        });

        if (element.matches("div.Form")) {
            lvl.forms.create(element);
        }

        // DataGrid
        element.querySelectorAll<HTMLElement>("div.DataGrid").forEach(element => {
            lvl.grids.create(element);
        });

        if (element.matches("div.DataGrid")) {
            lvl.grids.create(element);
        }
    });

htmx.on("htmx:beforeCleanupElement",
    (e: Event) => {
        const ev = (e as CustomEvent<{ elt: Element; }>);

        if (!(ev.detail.elt instanceof HTMLElement)) {
            return;
        }

        const element: HTMLElement = ev.detail.elt;

        // DataGrid
        element.querySelectorAll<HTMLElement>("div.DataGrid").forEach(element => {
            if (lvl.grids.has(element)) {
                lvl.grids.destroy(element);
            }
        });

        if (element.matches("div.DataGrid")) {
            if (lvl.grids.has(element)) {
                lvl.grids.destroy(element);
            }
        }

        // Form
        element.querySelectorAll<HTMLElement>("div.Form").forEach(element => {
            lvl.forms.destroy(element);
        });

        if (element.matches("div.Form")) {
            lvl.forms.destroy(element);
        }
    });

/* 
click handlers
*/

type clickHandle = (e: HTMLElement) => void;

const clickHandles: Record<string, clickHandle> = {
    "DataGrid-ButtonSelectAll": eventDataGridSelectAllRows,
    "DataGrid-ButtonSelectNone": eventDataGridSelectNone,
    "DataGrid-ButtonClearSearch": eventDataGridClearSearch,
    "Table-MoveRowUp": Table.tableMoveRowUp,
    "Table-MoveRowDown": Table.tableMoveRowDown,
};

document.addEventListener("click", (e) => {
    if (!(e.target instanceof HTMLElement)) {
        return;
    }

    for (const className in clickHandles) {
        if (e.target.classList.contains(className)) {
            clickHandles[className](e.target);
            return;
        }
    }
});

function eventDataGridSelectAllRows(target: HTMLElement) {
    const dg = lvl.grids.get(target);
    dg.selectAllRows();
}

function eventDataGridSelectNone(target: HTMLElement) {
    const dg = lvl.grids.get(target);
    dg.unselectAllRows();
}

function eventDataGridClearSearch(target: HTMLElement) {
    const form = mustClosest(target, "form");
    const input = mustQuerySelector<HTMLInputElement>(form, 'input[name="SearchValue"]');
    input.value = "";
    lvl.grids.get(target).reload();
}